import React from 'react';
import * as providerMessenger from '../../store/messengers/providerMessenger.js'
import RightArrow from './rightArrow.js'

class FullscreenProviderLicense extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null
    }
  }

  onProviderLoaded(loadedData) {
    this.setState(loadedData)
  }

  render() {
    let selected = null;
    if (this.state.selected) {
      selected = this.state.selected;
    } else if (this.props.pricingData) {
      selected = this.props.pricingData.selected;
    }
    return (
      selected ?
      <div className="selected-license" onClick={() => {this.props.actions.toggleMobileShopFrame()}}>
        <div className="license-price">{selected.price}</div>
        <RightArrow className="show-shop-frame"/>
        <div className="license-title">{selected.title}</div>
      </div> :
      null
    )
  }
}

export default FullscreenProviderLicense;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenProviderLicense.js